import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <div style={{
      background: "#f1f5f9",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between"
    }}>
      <h4>My App</h4>

      <div>
        <span>{user?.email}</span>
        <button onClick={logout} style={{ marginLeft: "10px" }}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;